import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'

axios.defaults.baseURL = process.env.VUE_APP_REST_ENDPOINT;

const { jwt } = useJwt(axios, {
  // Endpoints
  loginEndpoint: '/api/v1/prison-users/tokens',
  // refreshEndpoint: '/refresh-token',
  // logoutEndpoint: '/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'userTokenPT',
  storageRefreshTokenKeyName: 'refreshTokenCell',
})
export default jwt
